// mixins/device.js
const mobileMaxWidth = 767
const mobileWiderMaxWidth = 1023
const tabletMaxWidth = 1200
const smallDeviceMaxWidth = 1399
const mobileMaxWidthInclude = 768

export default {
  data() {
    return {
      windowWidth: null,
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth <= mobileMaxWidth
    },
    isWiderMobile() {
      return this.windowWidth <= mobileWiderMaxWidth
    },
    isTablet() {
      return this.windowWidth > mobileMaxWidth && this.windowWidth <= tabletMaxWidth
    },
    isDesktop() {
      return this.windowWidth > tabletMaxWidth
    },
    isSmallDevice() {
      return this.windowWidth >= smallDeviceMaxWidth
    },
    isMobileInclude() {
      return this.windowWidth <= mobileMaxWidthInclude
    },
  },
  methods: {
    updateWindowWidth() {
      if (window.visualViewport?.width) {
        this.windowWidth = Math.round(window.visualViewport.width)
      } else {
        this.windowWidth = window.innerWidth
      }
    },
    // Named, not an inline arrow: beforeDestroy has to pass removeEventListener
    // the same function reference that was added, or the listener stays on
    // window forever holding this component instance alive.
    handleOrientationChange() {
      setTimeout(this.updateWindowWidth, 300)
    }
  },
  mounted() {
    this.updateWindowWidth()

    window.addEventListener('resize', this.updateWindowWidth)
    window.addEventListener('orientationchange', this.handleOrientationChange)

    // отдельный слушатель на visualViewport, если поддерживается
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.updateWindowWidth)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth)
    window.removeEventListener('orientationchange', this.handleOrientationChange)

    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.updateWindowWidth)
    }
  }
}